<template>
  <div class="main-box main-content">
        <el-form ref="dataForm" class="main-form" :model="temp" :rules="rules" label-width="85px" label-suffix="：" size="small" v-enter-next>
          <el-collapse class="normal-el-collapse" v-model="activeNames">
            <el-collapse-item title="基本信息" name="1">
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item  label="姓名">
                      <el-input  v-model="temp.sickName" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item  label="档案编号">
                      <el-input  v-model="temp.archiveCode" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item  label="全科团队">
                      <el-input  v-model="temp.createdByTeamName" readonly></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item  label="录入医生">
                      <el-input  v-model="temp.createdByName" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item  label="随访日期" >
                      <el-date-picker class="input-bg" v-model="temp.followupTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%" @change="handleFollowupTimeChange"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <div class="inline-controls">
                      <el-form-item  label="随访方式">
                        <el-radio-group v-model="temp.followupWay" size="mini">
                          <el-radio-button label="1">门诊</el-radio-button>
                          <el-radio-button label="2">家庭</el-radio-button>
                        </el-radio-group>
                        <el-checkbox v-model="temp.addFlag" true-label="1" false-label="0">追加随访</el-checkbox>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item  label="随访机构" prop="orgName">
                      <el-input  v-model="temp.orgName" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="!!temp.preFollowupTime">
                    <el-form-item>
                      <template slot="label"><span style="color: red;">体检日期</span></template>
                      <span>{{temp.yearMedicalTime}}</span>
                      <el-button  type="primary"  size="mini" v-if="canExamine"  @click="importExamineData()">导入体检数据</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
            </el-collapse-item>
            <el-collapse-item title="症状" name="2">
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item >
                    <el-checkbox v-model="temp.asymptomatic" true-label="1" false-label="0">无症状</el-checkbox>
                    <el-checkbox v-model="temp.symptomPolydipsia" :disabled="temp.asymptomatic == 1" true-label="1" false-label="0">多饮</el-checkbox>
                    <el-checkbox v-model="temp.symptomPolyphagia" :disabled="temp.asymptomatic == 1" true-label="1" false-label="0">多食</el-checkbox>
                    <el-checkbox v-model="temp.symptomPolyuria" :disabled="temp.asymptomatic == 1" true-label="1" false-label="0">多尿</el-checkbox>
                    <el-checkbox v-model="temp.symptomBlurredVision" :disabled="temp.asymptomatic == 1" true-label="1" false-label="0">视力模糊</el-checkbox>
                    <el-checkbox v-model="temp.symptomInfection" :disabled="temp.asymptomatic == 1" true-label="1" false-label="0">感染</el-checkbox>
                    <el-checkbox v-model="temp.symptomQuadriplegia" :disabled="temp.asymptomatic == 1" true-label="1" false-label="0">手脚麻木</el-checkbox>
                    <el-checkbox v-model="temp.symptomJointGall" :disabled="temp.asymptomatic == 1" true-label="1" false-label="0">下肢浮肿</el-checkbox>
                    <el-checkbox v-model="temp.symptomWeightLoss" :disabled="temp.asymptomatic == 1" true-label="1" false-label="0">四肢发麻</el-checkbox>
                    <el-checkbox v-model="temp.symptomOther" :disabled="temp.asymptomatic == 1" true-label="1" false-label="0">体重明显下降</el-checkbox>
                    <el-input class="input-bg" v-model="temp.symptomOtherContent" :readonly="temp.symptomOther != '1'"  style="width: 200px;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="体征" name="3">
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item  label="血压"  label-width="110px">
                    <xr-input-number-range :precision="precision" v-model="temp.bpRange" from-placeholder="收缩压" to-placeholder="舒张压" append="mmHg"  @update-data="handleUpdatePressure" ></xr-input-number-range>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item  label="身高"  label-width="110px">
                    <el-input  v-model="temp.height" type="number" placeholder="请输入身高" @change="handleHeightChange">
                      <template slot="append">cm</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item  label="体重">
                    <xr-input-number-range :precision="precision" v-model="temp.weightRange" from-placeholder="请输入体重" to-placeholder="指导体重" append="kg" @update-data="handleUpdateWeight"></xr-input-number-range>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item  label="体重信息来源"  label-width="110px">
                    <el-select v-model="temp.weightType" placeholder="请选择" style="width: 100%;">
                      <el-option
                        v-for="option in weightTypeOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item  label="体质指数" label-width="110px">
                    <xr-input-number-range :precision="bmiPrecision" v-model="temp.bmiRange" from-placeholder="请输入体质指数" to-placeholder="指导体质指数"  :disabled="true"></xr-input-number-range>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item  label="其它">
                    <el-input  v-model="temp.heartRateMinute"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item  label="足背动脉搏动" label-width="110px" prop="footPulse">
                    <el-radio-group v-model="temp.footPulse">
                      <el-radio label="1" style="width:80px">触及正常</el-radio>
                      <el-radio label="2">减弱
                        <template>（</template>
                        <el-radio-group v-model="temp.footPulsex">
                          <el-radio label="1">双侧</el-radio>
                          <el-radio label="2">左侧</el-radio>
                          <el-radio label="3">右侧</el-radio>
                        </el-radio-group>
                        <template>)</template>
                      </el-radio>
                      <el-radio label="3">消失
                        <template>（</template>
                        <el-radio-group v-model="temp.footPulsexs">
                          <el-radio label="1">双侧</el-radio>
                          <el-radio label="2">左侧</el-radio>
                          <el-radio label="3">右侧</el-radio>
                        </el-radio-group>
                        <template>)</template>
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="生活方式指导" name="4">
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item  label="日吸烟量">
                    <xr-input-number-range :precision="precision" v-model="temp.smokeRange" from-placeholder="请输入日吸烟量" to-placeholder="指导" append="支" @update-data="handleUpdateSmoking"></xr-input-number-range>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item  label="日饮酒量">
                    <xr-input-number-range :precision="bmiPrecision" v-model="temp.drinkRange" from-placeholder="请输入体质指数" to-placeholder="指导体质指数" append="两" @update-data="handleUpdateDrinkPressure"></xr-input-number-range>

                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item  label="运动">
                    <el-input  v-model="temp.timesWeek" placeholder="请输入运动次数" style="width: 24%;">
                      <template slot="append">次/周</template>
                    </el-input>
                    <el-input  v-model="temp.minsTimes" placeholder="请输入运动时间" style="width: 24%;">
                      <template slot="append">分钟/次</template>
                    </el-input>
                    <span>/</span>
                    <el-input  v-model="temp.guideTimesWeek" placeholder="请输入指导次数" style="width: 24%;">
                      <template slot="append">次/周</template>
                    </el-input>
                    <el-input  v-model="temp.guideMinsTimes" placeholder="请输入指导时间" style="width: 24%;">
                      <template slot="append">分钟/次</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item  label="饮食情况" prop="staple">
                    <xr-input-number-range :precision="precision" v-model="temp.stapleRange" from-placeholder="请输入饮食情况" to-placeholder="指导" append="两" @update-data="handleUpdateStaple"></xr-input-number-range>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item  label="心理调整">
                    <el-radio-group v-model="temp.psychologyState" size="mini">
                      <el-radio-button
                        v-for="option in psychologyStateOptions"
                        :key="option.value"
                        :label="option.value">
                        {{ option.label }}
                      </el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item  label="遵医行为">
                    <el-radio-group v-model="temp.complianceState" size="mini">
                      <el-radio-button label="1">良好</el-radio-button>
                      <el-radio-button label="2">一般</el-radio-button>
                      <el-radio-button label="3">差</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="辅助检查" name="5">
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item  label="血糖" prop="fastingBloodGlucose">
                    <el-input  v-model="temp.fastingBloodGlucose" placeholder="请输入血糖值">
                      <template slot="append">mmol/L</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item  label="血糖测量时间" prop="bloodSugarTime" label-width="110px">
                    <el-radio-group v-model="temp.bloodSugarTime">
                      <el-radio label="0">空腹</el-radio>
                      <el-radio label="1">餐后</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item  label="餐后(小时)" prop="bloodSugarTimeContain" label-width="110px">
                    <el-input  v-model="temp.bloodSugarTimeContain" placeholder="请输入餐后时间"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item  label="糖化血红蛋白" prop="hbalc1" label-width="110px">
                    <el-input  v-model="temp.hbalc1" placeholder="请输入糖化血红蛋白">
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item  label="检查日期" prop="hbalcDate">
                    <el-date-picker v-model="temp.hbalcDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item prop="otherExamine">
                    <template slot="label">
                      <div>其他检查</div>
                      <div><el-button  type="primary"  size="mini" @click="importAuxiliaryExamine()">导入</el-button></div>
                    </template>

                    <el-input  v-model="temp.otherExamine" placeholder="请输入其他检查内容" type="textarea"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="其他" name="6">
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item  label="药物依从性"  size="mini" label-width="110px">
                    <el-radio-group v-model="temp.drugState" size="mini">
                      <el-radio-button
                        v-for="option in drugStateOptions"
                        :key="option.value"
                        :label="option.value">
                        {{ option.label }}
                      </el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item  label="药物不良反应"  size="mini" label-width="110px">
                    <el-radio-group v-model="temp.adr">
                      <el-radio-button label="0">无</el-radio-button>
                      <el-radio-button label="1">有</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="18">
                  <el-form-item>
                    <el-input  v-model="temp.adrRemark" placeholder="请输入不良反应内容"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item  label="低血糖反应"  size="mini" label-width="110px">
                    <el-radio-group v-model="temp.hypoglycemia">
                      <el-radio-button label="0">无</el-radio-button>
                      <el-radio-button label="1">偶尔</el-radio-button>
                      <el-radio-button label="3">频繁</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item  label="此次随访分类" size="mini" label-width="110px">
                    <el-radio-group v-model="temp.followupKind">
                      <el-radio-button label="1">控制满意</el-radio-button>
                      <el-radio-button label="2">控制不满意</el-radio-button>
                    </el-radio-group>
                    <el-checkbox v-model="temp.untowardEffect" true-label="1" false-label="0">不良反应</el-checkbox>
                    <el-checkbox v-model="temp.syndrome" true-label="1" false-label="0">并发症</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="用药情况" name="7">
              <!-- 现用药物 -->
              <div style="margin-bottom: 20px;">
                <el-table :data="[1, 2, 3]" style="width: 100%" border class="medicine-table">
                  <el-table-column prop="name" min-width="180">
                    <template slot="header">
                      <div style="display: flex; align-items: center;">
                        <span>现用药物名称</span>
                      </div>
                    </template>
                    <template slot-scope="scope">
                      <el-select
                        v-model="temp['physicName' + (scope.$index + 1)]"
                        filterable
                        placeholder="请选择或搜索药物"
                        style="width: 100%;">
                        <el-option
                          v-for="(item, index) in drugList"
                          :key="item.value + index"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="frequency" label="频次" min-width="120">
                    <template slot-scope="scope">
                      <el-input v-model="temp['frequency' + (scope.$index + 1)]" placeholder="请输入频次"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="dose" label="次剂量" min-width="120">
                    <template slot-scope="scope">
                      <el-input v-model="temp['physicDose' + (scope.$index + 1)]" placeholder="请输入次剂量"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="unit" label="单位" min-width="100">
                    <template slot-scope="scope">
                      <el-select  v-model="temp['physicUnit' + (scope.$index + 1)]"   placeholder="请选择单位" style="width: 100%;">
                        <el-option v-for="(item, index) in drugUnitList"  :key="item.value + index" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" min-width="80" fixed="right">
                    <template slot-scope="scope">
                      <el-button  type="primary" icon="el-icon-delete" size="small" @click="clearMedicineRow(scope.$index +1)" title="删除"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <!-- 处方药物 -->
              <div>
                <el-table :data="[4, 5, 6]" style="width: 100%" border class="medicine-table">
                  <el-table-column prop="name" min-width="180">
                    <template slot="header">
                      <div style="display: flex; align-items: center;">
                        <span>处方药物名称</span>
                      </div>
                    </template>
                    <template slot-scope="scope">
                      <el-select  v-model="temp['physicName' + (scope.$index + 4)]"  filterable  placeholder="请选择或搜索药物" style="width: 100%;">
                        <el-option v-for="(item, index) in drugList"  :key="item.value + index"  :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="frequency" label="频次" min-width="120">
                    <template slot-scope="scope">
                      <el-input v-model="temp['frequency' + (scope.$index + 4)]" placeholder="请输入频次"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="dose" label="次剂量" min-width="120">
                    <template slot-scope="scope">
                      <el-input v-model="temp['physicDose' + (scope.$index + 4)]" placeholder="请输入次剂量"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="unit" label="单位" min-width="100">
                    <template slot-scope="scope">
                      <el-select  v-model="temp['physicUnit' + (scope.$index + 4)]"   placeholder="请选择单位" style="width: 100%;">
                        <el-option v-for="(item, index) in drugUnitList"  :key="item.value + index" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" min-width="80" fixed="right">
                    <template slot-scope="scope">
                      <el-button type="primary" icon="el-icon-delete" size="small" @click="clearMedicineRow(scope.$index + 4)" title="删除"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <el-row :gutter="20" type="flex" align="middle" style="margin-top: 10px;">
                <el-col :span="2">
                  <el-form-item label="胰岛素"></el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label="种类">
                    <el-input v-model="temp.insulinKind" placeholder="请输入胰岛素种类"></el-input>
                  </el-form-item>
                </el-col>

                <!-- 用法用量 -->
                <el-col :span="9">
                  <el-form-item label="用法用量">
                    <el-input v-model="temp.insulinUsage" placeholder="请输入用法用量"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="转诊" name="8">
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item  label="原因" label-width="100px">
                    <el-checkbox v-model="temp.transferResonGlucose" true-label="1" false-label="0">连续2次随访血糖控制不满意</el-checkbox>
                    <el-checkbox v-model="temp.transferResonDrug" true-label="1" false-label="0">连续2次随访药物不良反应没有改善</el-checkbox>
                    <el-checkbox v-model="temp.transferResonSerious" true-label="1" false-label="0">有新的并发症出现或有并发症加重</el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item  label="其他" prop="transferReson">
                    <el-input  v-model="temp.transferReson" placeholder="请输入其他原因"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item  label="机构及科室" label-width="100px">
                    <el-input  v-model="temp.transferOrgDept" placeholder="请输入机构及科室"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="备注" name="9">
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item  label="备注" prop="remark">
                    <el-input  v-model="temp.remark" placeholder="请输入备注内容" type="textarea"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 下次随访日期 -->
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item  label="下次随访日期" label-width="110px">
                    <el-date-picker v-model="temp.followupNextTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item  label="随访医生" prop="followupDoctor">
                    <div class="inline-controls">
                      <el-select v-model="temp.followupDoctor" style="width: 180px;">
                        <el-option  v-for="item in staffList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                      <el-checkbox v-model="temp.nextAddFlag" true-label="1" false-label="0">追加随访</el-checkbox>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>

     </el-form>
  </div>
</template>
<script>

import {resetBloodFormData } from '../../../../utils/ph/ChronicUtils';
import {compareDate} from "../../../../utils/common/DateUtils";


export default {
    name: "glucoseInfo",
    data() {
      return {
        activeNames: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        dialogVisible: false,   //是否显示
        dialogName:'编辑糖尿病随访记录',
        type:'',
        archiveId: '',
        precision: 0,
        bmiPrecision: 2,                              //BMI精确度
        // 症状配置列表
        symptomOptions: [
          { label: '1', value: 'asymptomatic', text: '无症状' },
          { label: '2', value: 'symptomPolydipsia', text: '多饮' },
          { label: '3', value: 'symptomPolyphagia', text: '多食' },
          { label: '4', value: 'symptomPolyuria', text: '多尿' },
          { label: '5', value: 'symptomBlurredVision', text: '视力模糊' },
          { label: '6', value: 'symptomInfection', text: '感染' },
          { label: '7', value: 'symptomQuadriplegia', text: '手脚麻木' },
          { label: '8', value: 'symptomJointGall', text: '下肢浮肿' },
          { label: '9', value: 'symptomWeightLoss', text: '体重明显下降' },
          { label: '10', value: 'symptomOther', text: '其它' },
        ],
        staffList: [],
        weightTypeOptions: [
          {label:'自述',value:'1'},
          {label:'未查',value:'2'},
          {label:'现场测量',value:'3'},
        ],
        psychologyStateOptions:[
          {label:'良好', value:'1'},
          {label:'一般', value:'2'},
          {label:'差', value:'3'},
        ],
        drugStateOptions:[
          {label:'规律', value:'1'},
          {label:'间断', value:'2'},
          {label:'不服药', value:'3'},
          {label:'医嘱无需用药', value:'4'},
        ],
        drugList: [],      //药品
        drugUnitList:[],  //药品单位
        temp: {
          // 基本信息
          id: '',
          orgId: '',
          orgName: '',
          followupNo: '',
          dataYear: '',
          dataQuarter: '',
          archiveId: '',
          archiveCode: '',
          sickName: '',
          identityCardNo: '',
          followupTime: '',
          followupWay: '',
          addFlag: '',
          addFlagName: '',
          asymptomatic: '',
          symptomPolydipsia: '',
          symptomPolyphagia: '',
          symptomPolyuria: '',
          symptomBlurredVision: '',
          symptomInfection: '',
          symptomQuadriplegia: '',
          symptomJointGall: '',
          symptomWeightLoss: '',
          symptomOther: '',
          symptomOtherContent: '',
          systolic: '',
          diastolic: '',
          height: '',
          weight: '',
          guideWeight: '',
          weightType: '',
          weightTypeName: '',
          bmi: '',
          guideBmi: '',
          heartRate: '',
          heartRateMinute: '',
          staple: '',
          guideStaple: '',
          strengthType: '',
          strengthTypeLight: '',
          footPulse: '',
          footPulsex: '',
          footPulsexs: '',
          somking: '',
          somkingExp: '',
          drink: '',
          guideDrink: '',
          drinkExp: '',
          timesWeek: '',
          timesWeekExp: '',
          minsTimes: '',
          minsTimesExp: '',
          guideTimesWeek: '',
          guideMinsTimes: '',
          saltSituation: '',
          guideSaltSituation: '',
          psychologyState: '',
          psychologyStateName: '',
          complianceState: '',
          fastingBloodGlucose: '',
          bloodSugarTime: '',
          bloodSugarTimeContain: '',
          hbalc1: '',
          hbalcDate: '',
          otherExamine: '',
          drugState: '',
          drugStateCode: '',
          drugStateName: '',
          adr: '',
          adrRemark: '',
          hypoglycemia: '',
          followupKind: '',
          untowardEffect: '',
          syndrome: '',
          physicName1: '',
          frequency1: '',
          physicDose1: '',
          physicUnit1: '',
          physicName2: '',
          frequency2: '',
          physicDose2: '',
          physicUnit2: '',
          physicName3: '',
          frequency3: '',
          physicDose3: '',
          physicUnit3: '',
          physicName4: '',
          frequency4: '',
          physicDose4: '',
          physicUnit4: '',
          physicName5: '',
          frequency5: '',
          physicDose5: '',
          physicUnit5: '',
          physicName6: '',
          frequency6: '',
          physicDose6: '',
          physicUnit6: '',
          insulinKind: '',
          insulinUsage: '',
          transferResonGlucose: '',
          transferResonDrug: '',
          transferResonSerious: '',
          transferReson: '',
          transferOrgDept: '',
          followupNexttime: '',
          nextAddFlag: '',
          nextAddFlagName: '',
          followupDoctor: '',
          followupDoctorName: '',
          remark: '',
          qualifiedFlag: '',
          createdTime: '',
          createdById: '',
          createdByName: '',
          createdByTeamId: '',
          createdByTeamName: '',
          updatedTime: '',
          updatedById: '',
          updatedByName: '',
          dataType: '',
          processStatus: '',
          errorMessage: '',
          ifDeleted: '',
          bpRange: ["", ""],
          weightRange:["",""],
          bmiRange:["",""],
          smokeRange:["",""],
          drinkRange:["", ""],
          stapleRange: ["", ""],
        },
        rules: {
        },
      }
    },
    computed: {
      symptomArray: {
        get() {
          const selectedLabels = [];
          this.symptomOptions.forEach(item => {
            const val = this.temp[item.value];
            if (val === "1" || val === 1) {
              selectedLabels.push(item.label);
            }
          });
          return selectedLabels;
        },
        set(val) {
          this.symptomOptions.forEach(item => {
            const isSelected = val.includes(item.label);
            this.temp[item.value] = isSelected ? "1" : null;
          });
        }
      },
      canExamine(){
        if(!!this.temp.preFollowupTime && !!this.temp.yearMedicalTime && compareDate(this.temp.yearMedicalTime, this.temp.preFollowupTime)){
          return true;
        }
        return false;
      }
    },
    watch: {
      'temp.psychologyState'(newVal) {
        const foundOption = this.psychologyStateOptions.find(option => option.value === newVal);
        if (foundOption) {
          this.temp.psychologyStateName = foundOption.label
        }
      },
      'temp.drugState'(newVal) {
        const foundOption = this.drugStateOptions.find(option => option.value === newVal);
        if (foundOption) {
          this.temp.drugStateName = foundOption.label
        }
      },
      // 血糖>= 7 时自动选择控制不满意
      'temp.fastingBloodGlucose'(newVal) {
        if (newVal !== '' && !isNaN(newVal) && parseFloat(newVal) >= 7) {
          this.temp.followupKind = '2'
        }else{
          this.temp.followupKind = '1'
        }
      },
      // 当选择控制不满意时,勾选追加随访
      'temp.followupKind'(newVal) {
        if (newVal === '2') {
          this.temp.nextAddFlag = '1'
        }else{
          this.temp.nextAddFlag ='0'
        }
      },
      //追加随访勾选状态: 更新下次随访日期
      'temp.nextAddFlag'(newVal) {
          if(!this.temp.followupTime) return;
          this.calculateNextFollowupTime();
      }
    },
    methods: {
      //初始化
     init(type, id, archiveId){
       this.type = type;
       this.archiveId = archiveId
       this.temp.id = id;
       this.$nextTick(()=>{
          this.getPageInfo(type, id);
       })
     },
     //获取页面具体信息
     getPageInfo(type, id){
     	return this.request({
     	  method:'post',
     	  url:'/web/service',
     	  params:{
     	    'method': 'tPhDataChronicGlucose_getPageInfo',
          'type': type,
          'id': id,
          'archiveId': this.archiveId
     	  }
     	}).then((response) => {
         // 请求成功返回的数据
         //如果返回编码不为0，提示失败语
         if(response.code != '0'){
           this.$message.error(response.msg);
           return false;
         }

         if(response.data.drugList) {                     //药品
           this.drugList = response.data.drugList;
         }
         if(response.data.drugUnitList) {                 //药品单位
           this.drugUnitList = response.data.drugUnitList;
         }

        if(response.data.staffList) {                   //药品单位
          this.staffList = response.data.staffList;
        }

        if(!!response.data.info) {
          // 将后端返回的数据映射到temp
          this.temp = Object.assign(this.temp, response.data.info);
          //处理xt-input-number-range数据
          this.handlerNumberRangeData(response.data.info)
        }
       })
     },

     handlerNumberRangeData(data){
       //血压
       let bpRange = [];
       bpRange.push(data.systolic || "");
       bpRange.push(data.diastolic || "");
       this.temp.bpRange = bpRange;
       //体重
       let weightRange = [];
       weightRange.push(data.weight || '');
       weightRange.push(data.guideWeight || '');
       this.temp.weightRange = weightRange;
       //BMI
       let bmiRange = [];
       bmiRange.push(data.bmi || '');
       bmiRange.push(data.guideBmi || '');
       this.temp.bmiRange = bmiRange;
       //日吸烟量
       let smokeRange = [];
       smokeRange.push(data.somking || '');
       smokeRange.push(data.somkingExp || '');
       this.temp.smokeRange = smokeRange;
       //日饮酒量
       let drinkRange = [];
       drinkRange.push(data.drink|| '');
       drinkRange.push(data.guideDrink|| '');
       this.temp.drinkRange = drinkRange;
       //饮食情况
       let stapleRange = [];
       stapleRange.push(data.staple || '');
       stapleRange.push(data.guideStaple || '');
       this.temp.stapleRange = stapleRange;
     },
      //导入辅助检查
      importAuxiliaryExamine(){
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method': 'tPhChronicCommon_importAuxiliaryExamine',
            'archiveId': this.archiveId,
            'followupTime': this.temp.followupTime
          }
        }).then((response) => {
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          if(!!response.data.otherExamine) {
            this.temp.otherExamine = response.data.otherExamine;
          }
        })
      },
      //导入体检数据
      importExamineData(){
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method': 'tPhChronicCommon_importExamineData',
            'archiveId': this.archiveId,
            'followupTime': this.temp.followupTime,
            'preFollowupTime': this.temp.preFollowupTime
          }
        }).then((response) => {
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          if(!!response.data.diastolic && !!response.data.systolic) {
            this.temp.diastolic = response.data.diastolic;
            this.temp.systolic = response.data.systolic;
            let bpRange = [];
            bpRange.push(response.data.systolic);
            bpRange.push(response.data.diastolic);
            this.temp.bpRange = bpRange;
          }

          if(!!response.data.height) {
            this.temp.height = response.data.height;
          }
          if(!!response.data.heartRate) {
            this.temp.heartRate = response.data.heartRate;
          }
          if(!!response.data.weight && !!response.data.guideWeight) {
            this.temp.weight = response.data.weight;
            this.temp.guideWeight = response.data.guideWeight;
            let weightRange = [];
            weightRange.push(response.data.weight);
            weightRange.push(response.data.guideWeight);
            this.temp.weightRange = weightRange;
          }

          if(!!response.data.bmi && !!response.data.guideBmi) {
            this.temp.bmi = response.data.bmi;
            this.temp.guideBmi = response.data.guideBmi;
            let bmiRange = [];
            bmiRange.push(response.data.bmi);
            bmiRange.push(response.data.guideBmi);
            this.temp.bmiRange = bmiRange;
          }

          if(!!response.data.somking) {
            this.temp.somking = response.data.somking;
            this.temp.somkingExp = "0";
            let smokeRange = [];
            smokeRange.push(response.data.somking);
            smokeRange.push("0");
            this.temp.smokeRange = smokeRange;
          }

          if(!!response.data.drink) {
            this.temp.drink = response.data.drink;
            this.temp.guideDrink = "0";
            let drinkRange = [];
            drinkRange.push(response.data.drink);
            drinkRange.push("0");
            this.temp.drinkRange = drinkRange;
          }
          if(!!response.data.timesWeek) {
            this.temp.timesWeek = response.data.timesWeek;
          }
          if(!!response.data.minsTimes) {
            this.temp.minsTimes = response.data.minsTimes;
          }
          if(!!response.data.fastingBloodGlucose) {
            this.temp.fastingBloodGlucose = response.data.fastingBloodGlucose;
          }

          if(!!response.data.otherExamine) {
            this.temp.otherExamine = response.data.otherExamine;
          }


        })
      },
     //复制上一期内容
     copyLastData(){
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method': 'tPhDataChronicGlucoseFollow_copyLastData',
            'archiveId': this.archiveId
          }
        }).then((response) => {
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          if(!!response.data) {
            this.temp = Object.assign(this.temp, response.data);
          }

          //判断是否可以根据体检做随访
          if(!!this.temp.preFollowupTime && !!this.temp.yearMedicalTime && compareDate(this.temp.yearMedicalTime, this.temp.preFollowupTime)){
            this.$message.success('本次随访可导入体检日期，点击下方的【导入体检数据】按钮导入体检数据！');
          }

        })
     },
     //保存
     save(formName){
       let url = '/web/service?method=tPhDataChronicGlucose_edit'
       if (this.type === 'save') {
         url = '/web/service?method=tPhDataChronicGlucose_save'
       }
       this.$refs[formName].validate((valid) => {
         if (valid) {
           return this.request({
             method: 'post',
             url: url,
             params: this.temp
           }).then((response) =>{
             if (response.code === 0) {
               this.$message({
                 message: '操作成功',
                 type: 'success',
                 duration: 1500,
                 onClose: () => {
                   this.dialogVisible = false
                   this.$emit('refreshTree')
                 }
               })
             } else {
               this.$message.error(response.msg)
             }
           })
         } else {
           console.log('error submit!!');
           return false;
         }
       });
     },
      //随访日期变化时计算下次随访日期
      handleFollowupTimeChange(){
        if(!this.temp.followupTime) return;
        this.calculateNextFollowupTime();
      },
      //计算下次随访日期
      calculateNextFollowupTime(){
        const followupDate = new Date(this.temp.followupTime);
        let nextDate = new Date(followupDate);

        if(this.temp.nextAddFlag === '1'){
          // 如果勾选追加随访，下次随访日期 = 随访日期 + 14天
          nextDate.setDate(nextDate.getDate() + 14);
        } else {
          // 如果不勾选，下次随访日期 = 随访日期 + 3个月
          nextDate.setMonth(nextDate.getMonth() + 3);
        }

        const year = nextDate.getFullYear();
        const month = String(nextDate.getMonth() + 1).padStart(2, '0');
        const day = String(nextDate.getDate()).padStart(2, '0');

        this.temp.followupNextTime = `${year}-${month}-${day}`;
      },
      //更新血压
      handleUpdatePressure(systolic, diastolic){
        this.temp.systolic = systolic;
        this.temp.diastolic = diastolic;
      },
      //身高变化时自动计算BMI
      handleHeightChange(){
        this.calculateBMI();
      },
      //更新饮酒
      handleUpdateDrinkPressure(drink,guideDrink){
        this.temp.drink = drink
        this.temp.guideDrink =guideDrink
      },
      //更新体重并自动计算BMI
      handleUpdateWeight(weight,guideWeight){
        this.temp.weight = weight
        this.temp.guideWeight = guideWeight
        this.calculateBMI();
      },
      //计算BMI：BMI = 体重(kg) / 身高(m)²
      calculateBMI(){
        if(!this.temp.height || this.temp.height <= 0){
          this.temp.bmi = '';
          this.temp.guideBmi = '';
          this.temp.bmiRange = ['', ''];
          return;
        }

        const heightInMeter = this.temp.height / 100; // 转换为米

        // 计算当前BMI
        if(this.temp.weight && this.temp.weight > 0){
          const bmi = this.temp.weight / (heightInMeter * heightInMeter);
          this.temp.bmi = parseFloat(bmi.toFixed(this.bmiPrecision));
        } else {
          this.temp.bmi = '';
        }

        // 计算指导BMI
        if(this.temp.guideWeight && this.temp.guideWeight > 0){
          const guideBmi = this.temp.guideWeight / (heightInMeter * heightInMeter);
          this.temp.guideBmi = parseFloat(guideBmi.toFixed(this.bmiPrecision));
        } else {
          this.temp.guideBmi = '';
        }

        // 更新bmiRange数组
        this.temp.bmiRange = [this.temp.bmi, this.temp.guideBmi];
      },
      //更新吸烟量
      handleUpdateSmoking(somking,somkingExp){
        this.temp.somking = somking
        this.temp.somkingExp = somkingExp
      },
      //更新BMI
      handleUpdateBMI(bmi,guideBmi){
        this.temp.bmi = bmi
        this.temp.guideBmi = guideBmi
      },
      //更新饮食
      handleUpdateStaple(staple,guideStaple){
         this.temp.staple = staple
         this.temp.guideStaple = guideStaple
      },
      validateForm(){
        if(!this.symptomArray){
          this.$message.warning('请勾选症状！');
          return false
        }
        if(!this.temp.followupTime){
          this.$message.warning('随访日期不能为空')
          return false
        }
        if(!this.temp.followupNextTime){
          this.$message.warning('下次随访日期不能为空')
          return false
        }
        return true
      },
      //取消
      close(){
        this.dialogVisible=false
      },
      clearMedicineRow(index) {
       if (this.temp) {
           this.temp[`physicName${index}`] = '';
           this.temp[`frequency${index}`] = '';
           this.temp[`physicDose${index}`] = '';
           this.temp[`physicUnit${index}`] = '';
       }
     },
      // 添加处方药物
      addPrescriptionMedicine() {
        this.temp.prescriptionMedicines.push({ name: '', frequency: '', dose: '', unit: '' })
      },
      //表单重置
      resetTemp(){
        this.temp = resetBloodFormData(this.temp);
      },
    }
  }
</script>

<style scoped>
.main-box{
  overflow-x: hidden;
  overflow-y: auto;
}
.input-bg .el-input__inner {
    background-color: #fff8d1 !important;
}
.main-form /deep/ .el-form-item__label {
    font-weight: 600 !important;
}
/* 用药情况表格样式 */
.medicine-table ::v-deep .el-table__header th {
  background-color: #f5f7fa !important;
  height: 40px !important;
  padding: 4px 0 !important;
  text-align: center !important;
}
.medicine-table ::v-deep .el-table__header th .cell {
  text-align: center !important;
}
.medicine-table ::v-deep .el-table__body td {
  height: 40px !important;
  padding: 4px 0 !important;
  text-align: center !important;
}
.medicine-table ::v-deep .el-table__body td .cell {
  text-align: center !important;
}
.medicine-table ::v-deep .el-button {
  border: none !important;
  background: transparent !important;
  color: #F56C6C !important;
}
.medicine-table ::v-deep .el-button:hover {
  background: transparent !important;
  color: #c45656 !important;
}

.el-tab-pane {
  margin-bottom: 10px;
}
.inline-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/ph/archive/glucose/glucose-add-or-edit.vue